// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Години прийому» (Reception hours, ключ `reception`, група `constituents`). */
export const receptionHoursManifest: IModuleManifest = {
  key: 'reception',
  group: 'constituents',
  slug: 'reception-hours',
  prefix: 'RCP',
  name: { en: 'Reception hours', uk: 'Години прийому' },
  entities: [
    { key: 'reception', slug: 'reception', name: { en: 'Reception hours', uk: 'Години прийому' }, main: true },
    { key: 'rpoint', slug: 'rpoint', name: { en: 'MP reception offices', uk: 'Приймальні депутата' }, main: false },
    { key: 'reception_slot', slug: 'reception-slot', name: { en: 'Reception Slots', uk: 'Часові слоти' }, main: false },
    { key: 'reception_visitor', slug: 'reception-visitor', name: { en: 'Reception Visitors', uk: 'Відвідувачі' }, main: false },
    { key: 'reception_follow_up', slug: 'reception-follow-up', name: { en: 'Reception Follow-ups', uk: 'Подальші дії' }, main: false },
    { key: 'reception_status', slug: 'reception-status', name: { en: 'Reception Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/receptionHoursSlice').then((m) => m.receptionHoursSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
